import { Component, Input } from '@angular/core';

@Component({
  selector: 'eic-company-offices-and-contacts',
  templateUrl: './company-offices-and-contacts.component.html',
  styleUrls: ['../../project-display.styles.scss',
              './company-offices-and-contacts.component.scss']
})
export class CompanyOfficesAndContactsComponent {
  @Input() company: any;

}
